import React, { memo, useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { practiceTemplatesDetails, savePracticeTemplates, practiceCategories, removePracticeTemplates, copyTemplate } from "../../services/pratice_templates";
import Switch from "../../components/shared/switch";

import ContentTranslation from "../../components/ContentTranslation";
import PracticeContentPreview from '../../components/PracticeContentPreview'
import AgeSlider from "../../components/AgeSlider";
import Select from "react-select";

import { filterEmptyTranslations } from "../../services/filters";
import ImagePicker from "../../components/shared/ImagePicker";
import ConfirmRemoveDialog from '../../components/ConfirmRemoveDialog';
import CommentsButton from '../../components/CommentsButton';
import ReturnButton from '../../components/ReturnButton';

const PracticeTemplateForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, clone_id } = useParams();
  const { t } = useTranslation();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const [language, setLanguage] = useState('en')
  const [categories, setCategories] = useState([])
  const [practice, setPractice] = useState({
    minimum_age: 5,
    maximum_age: 15,
    exercises_practices_attributes: [],
    practice_template_translations_attributes: [{
      title: '',
      content: '',
      locale: language,
      published: true
    }]
  })

  useEffect(() => {
    const loadCategories = async () => {
      const { categories } = await practiceCategories();
      setCategories(categories);
    };

    loadCategories()
  }, [location.pathname])

  useEffect(() => {
    const loadData = async () => {
      if (!!id) {
        const { practice_template } = await practiceTemplatesDetails(id);
        setPractice(practice_template);
      } else if (!!clone_id) {
        try {
          const { practice_template } = await copyTemplate(clone_id);
          setPractice(practice_template);
        } catch (e) {
          navigate(-1)
        }
      }
    };

    loadData()
  }, [location.pathname])

  const save = async () => {
    const data = { ...practice }
    data.practice_template_translations_attributes = filterEmptyTranslations(practice.practice_template_translations_attributes)
    const response = await savePracticeTemplates(data);
    navigate("/club_admin/practice_templates/");
  }

  const remove = async () => {
    if (!practice?.id || !!practice.locked) {
      return;
    }
    setShowConfirmDialog(true);
  };

  const confirmRemove = async () => {
    await removePracticeTemplates(id)
    navigate("/club_admin/practice_templates/")
  };

  const clone = () => {
    navigate(`/club_admin/practice_templates/${id}/copy`)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <div className="form-container practice-form">
      <ReturnButton/>
      <div className="form-container-header">
        { id && t('practice_templates.edit')}
        { clone_id && t('practice_templates.copy')}
        { !id && !clone_id && t('practice_templates.new')}
      </div>
      <div className="form-container-header">
        <div className="form-container-header-title flex1">
          {practice?.title}
        </div>
        <div className="form-container-header-status">{t('common.published')}
          <Switch value={practice?.published}
                  onChange={(value) => setPractice({
                    ...practice,
                    published: value
                  })}/>
        </div>
      </div>

      <PracticeContentPreview practiceData={practice} setPracticeData={setPractice} libraries={['Exercise','Aktion', 'ExerciseCollection']}/>
      
      <div className="form-container-content">
        <div className="exercise-form-year_span">
          <div className="heading">{t('common.year_span')}</div>
          <AgeSlider
            minimum_age={practice?.minimum_age}
            maximum_age={practice?.maximum_age}
            onChange={({ minimum_age, maximum_age }) => setPractice({ ...practice, minimum_age, maximum_age })}>
          </AgeSlider>
        </div>
        <div className="form-container-content-right-narrow"></div>
      </div>


      <div className="form-container-content">
        <ContentTranslation data={practice?.practice_template_translations_attributes}
                            onChange={values => setPractice({
                              ...practice,
                              practice_template_translations_attributes: values
                            })}/>
        {practice.id && <CommentsButton entityType= {'practice_templates'}/> }
      </div>

      <div className="heading">{t('practice_templates.action_type')}</div>
      <Select
        closeMenuOnSelect={true}
        options={categories.map(item => ({ value: item.id, label: item.title }))}
        onChange={(selected) => setPractice({...practice, category: selected.value, category_title: selected.label })}
        value={{ value: practice?.category, label: practice?.category_title || practice?.category_title }}
      />

      <div className="heading">{t('practice_templates.preview_image')}</div>
      <ImagePicker imageUrl={practice.image_url} onChange={(image) => setPractice({...practice, image})}/>


      <div className="form-container-actions">
        <button className='button button-delete' onClick={remove}>{t('practice_templates.delete')}</button>
        { id && <button className='button button-clone' onClick={clone}>
          {t('practice_templates.copy_button')} <i className="icon icon-docs pointer"></i>
        </button> }
        <div className="flex-end">
          <button className="button" onClick={() => navigate("/club_admin/practice_templates/")}>{t('buttons.common.cancel')}</button>
          <button className="button button-primary" onClick={save}>{t('buttons.common.save-changes')}</button>
        </div>

      </div>
      {showConfirmDialog && (
        <ConfirmRemoveDialog
          title={t('practice_templates.remove_practice_template', { title: practice?.title })}
          confirm={confirmRemove}
          close={() => setShowConfirmDialog(false)}
        />
      )}
    </div>
  )
};

export default memo(PracticeTemplateForm);
